<template>
	<div class="fz-12">
        {{ row[column.propType] }}
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {},
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped></style>
